import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.object.keys";
import _typeof from "/var/lib/jenkins/workspace/yesep-ui/node_modules/@babel/runtime-corejs2/helpers/esm/typeof.js";
import _mergeJSXProps2 from "@vue/babel-helper-vue-jsx-merge-props";
import _mergeJSXProps from "@vue/babel-helper-vue-jsx-merge-props";
import _defineProperty from "/var/lib/jenkins/workspace/yesep-ui/node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js";
import "core-js/modules/es6.function.name";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import "core-js/modules/es6.array.find";
import "core-js/modules/web.dom.iterable";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import Menu from 'ant-design-vue/es/menu';
import Icon from 'ant-design-vue/es/icon';
var Item = Menu.Item,
    SubMenu = Menu.SubMenu;
export default {
  name: 'SMenu',
  props: {
    menu: {
      type: Array,
      required: true
    },
    theme: {
      type: String,
      required: false,
      default: 'dark'
    },
    mode: {
      type: String,
      required: false,
      default: 'inline'
    },
    collapsed: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data: function data() {
    return {
      openKeys: [],
      selectedKeys: [],
      cachedOpenKeys: []
    };
  },
  computed: {
    rootSubmenuKeys: function rootSubmenuKeys(vm) {
      var keys = [];
      vm.menu.forEach(function (item) {
        return keys.push(item.path);
      });
      return keys;
    }
  },
  mounted: function mounted() {
    this.updateMenu();
  },
  watch: {
    collapsed: function collapsed(val) {
      if (val) {
        this.cachedOpenKeys = this.openKeys.concat();
        this.openKeys = [];
      } else {
        this.openKeys = this.cachedOpenKeys;
      }
    },
    $route: function $route() {
      this.updateMenu();
    }
  },
  methods: {
    // select menu item
    onOpenChange: function onOpenChange(openKeys) {
      var _this = this;

      // 在水平模式下时执行，并且不再执行后续
      if (this.mode === 'horizontal') {
        this.openKeys = openKeys;
        return;
      } // 非水平模式时


      var latestOpenKey = openKeys.find(function (key) {
        return !_this.openKeys.includes(key);
      });

      if (!this.rootSubmenuKeys.includes(latestOpenKey)) {
        this.openKeys = openKeys;
      } else {
        this.openKeys = latestOpenKey ? [latestOpenKey] : [];
      }
    },
    updateMenu: function updateMenu() {
      var routes = this.$route.matched.concat();
      var hidden = this.$route.meta.hidden;

      if (routes.length >= 3 && hidden) {
        routes.pop();
        this.selectedKeys = [routes[routes.length - 1].path];
      } else {
        this.selectedKeys = [routes.pop().path];
      }

      var openKeys = [];

      if (this.mode === 'inline') {
        routes.forEach(function (item) {
          openKeys.push(item.path);
        });
      } //update-begin-author:taoyan date:20190510 for:online表单菜单点击展开的一级目录不对


      if (!this.selectedKeys || this.selectedKeys[0].indexOf(":") < 0) {
        this.collapsed ? this.cachedOpenKeys = openKeys : this.openKeys = openKeys;
      } //update-end-author:taoyan date:20190510 for:online表单菜单点击展开的一级目录不对

    },
    // render
    renderItem: function renderItem(menu) {
      if (!menu.hidden) {
        return menu.children && !menu.alwaysShow ? this.renderSubMenu(menu) : this.renderMenuItem(menu);
      }

      return null;
    },
    renderMenuItem: function renderMenuItem(menu) {
      var h = this.$createElement;
      var target = menu.meta.target || null;
      var tag = target && 'a' || 'router-link';
      var props = {
        to: {
          name: menu.name
        }
      }; // console.log("----------index menu start------------");
      // console.log(menu);
      // console.log("----------index menu end------------");

      if (menu.route && menu.route === '0') {
        props = {
          to: {
            path: menu.path
          }
        };
      }

      var attrs = {
        href: menu.path,
        target: menu.meta.target
      };

      if (menu.children && menu.alwaysShow) {
        // 把有子菜单的 并且 父菜单是要隐藏子菜单的
        // 都给子菜单增加一个 hidden 属性
        // 用来给刷新页面时， selectedKeys 做控制用
        menu.children.forEach(function (item) {
          item.meta = Object.assign(item.meta, {
            hidden: true
          });
        });
      }

      return h(Item, _mergeJSXProps([{}, {
        key: menu.path
      }]), [h(tag, {
        "props": _objectSpread({}, props),
        "attrs": _objectSpread({}, attrs)
      }, [this.renderIcon(menu.meta.icon), h("span", [menu.meta.title])])]);
    },
    renderSubMenu: function renderSubMenu(menu) {
      var _this2 = this;

      var itemArr = [];

      if (!menu.alwaysShow) {
        menu.children.forEach(function (item) {
          return itemArr.push(_this2.renderItem(item));
        });
      }

      return h(SubMenu, _mergeJSXProps2([{}, {
        key: menu.path
      }]), [h("span", {
        "slot": "title"
      }, [this.renderIcon(menu.meta.icon), h("span", [menu.meta.title])]), itemArr]);
    },
    renderIcon: function renderIcon(icon) {
      var h = this.$createElement;

      if (icon === 'none' || icon === undefined) {
        return null;
      }

      var props = {};
      _typeof(icon) === 'object' ? props.component = icon : props.type = icon;
      return h(Icon, {
        "props": _objectSpread({}, props)
      });
    }
  },
  render: function render() {
    var _this3 = this;

    var h = arguments[0];
    var mode = this.mode,
        theme = this.theme,
        menu = this.menu;
    var props = {
      mode: mode,
      theme: theme,
      openKeys: this.openKeys
    };
    var on = {
      select: function select(obj) {
        _this3.selectedKeys = obj.selectedKeys;

        _this3.$emit('select', obj);
      },
      openChange: this.onOpenChange
    };
    var menuTree = menu.map(function (item) {
      if (item.hidden) {
        return null;
      }

      return _this3.renderItem(item);
    }); // {...{ props, on: on }}

    return h(Menu, {
      "props": _objectSpread({}, props),
      "on": _objectSpread({}, on),
      "model": {
        value: _this3.selectedKeys,
        callback: function callback($$v) {
          _this3.selectedKeys = $$v;
        }
      }
    }, [menuTree]);
  }
};